export function assertUnreachable(_, message) {
    throw new Error(message ?? "Unreachable");
}
